import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link, NavLink } from 'react-router-dom'

export default function TopNav() {
    return (
        <div>
            <Navbar fixed="top" className="navbar" collapseOnSelect expand="lg" >
                <Container fluid>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Brand href="#home"> <img className="logo" src="images/logo/logo.png" /> </Navbar.Brand>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav defaultActiveKey="/" className="me-auto nav ">
                            <NavLink className="nav-link" as={Link} to='/' >Home</NavLink>
                            <NavDropdown title="Kalpataru" id="collasible-nav-dropdown" renderMenuOnMount={true}>
                                <NavDropdown.Item as={Link} to='/about'>About Kalpataru </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/kalpataru/hospitals'>About Kalpataru Hospitals</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/kalpataru/stores'>About Kalpataru Stores</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/kalpataru/medical/team'>Medical Team</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/kalpataru/accomodation'>Accomodation</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Treatments" id="collasible-nav-dropdown" renderMenuOnMount={true}>
                                <NavDropdown.Item as={Link} to='/Treatments/Arthocare'>Artho Care</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/Tretments/Neurocare'>Neuro Care</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/Treatments/Obesity'>Obesity</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/Treatments/womenchildcare'>WomenChild Care</NavDropdown.Item>
                                {/* <NavDropdown.Item as={Link} to='/panch/upachar'>Child Care</NavDropdown.Item> */}
                                <NavDropdown.Item as={Link} to='/Treatments/Beautycare'>Beauty Care</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/Treatments/Diagnosis'>Diagnosis</NavDropdown.Item>
                            </NavDropdown>
                            {/* <NavDropdown title="Our Products" id="collasible-nav-dropdown" renderMenuOnMount={true}>
                                <NavDropdown.Item as={Link} to='/general/product'>General Products</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/medical/product'>Medical Products</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/organic/product'>Organic Products</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/untensil'>Utensils</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/herbal/plants'>Herbal Plants</NavDropdown.Item>
                            </NavDropdown> */}
                            <NavDropdown title="Events" id="collasible-nav-dropdown" renderMenuOnMount={true}>
                                <NavDropdown.Item as={Link} to='/ayurveda/expo'> Ayurveda Expo </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to='/yogacamp'> Yoga Camps </NavDropdown.Item>
                                {/* <NavDropdown.Item as={Link} to='/nama/parayan'> Swarna Bindu </NavDropdown.Item> */}
                                <NavDropdown.Item as={Link} to='/shishu/swarna'> Shishu-Swarna </NavDropdown.Item>
                            </NavDropdown>
                            <NavLink className="nav-link" as={Link} to='/franchise'>Franchise</NavLink>
                            <NavLink className="nav-link" as={Link} to='/blog'>Blogs</NavLink>
                            <NavLink className="nav-link" as={Link} to='/contact'>Contact Us</NavLink>
                        </Nav>
                        <Nav>
                            <NavLink className="nav-link-buy" as={Link} to='/buy/products'> Buy Products </NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
